export default function blogHeight(){
     
     const blogSwiper = document.querySelector('.blogSwiper');
     if(!blogSwiper) return null;
     const blogContents = Array.from(blogSwiper.querySelectorAll('.blog__content'));
     let maxHeight = 0;
     

     for (let i = 0; i < blogContents.length; i++) {
          const blog = blogContents[i];
     
          if(maxHeight < blog.clientHeight){
               maxHeight = blog.clientHeight
          }
     }
     
     document.body.style.setProperty('--blog-height', maxHeight + 'px');

     return;
}


export function backLink(){
     const linkBack = document.querySelectorAll('.link-back');
     if(!linkBack) return false;
     linkBack.forEach(link => {
          link.addEventListener('click', e => {
               e.preventDefault();
               window.history.go(-1); 
               console.log('log')
               return false;
          })
          
          
     })
}
